// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5017f0ab","590":"bf929259","946":"b6270e9e"}[chunkId] + ".chunk.js";
};